var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Server"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Server",
    clipPath: "url(#clip-Server)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "server-2",
    "data-name": "server",
    transform: "translate(5 -0.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 24.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M457.786,24.774H24.065C10.8,24.774,0,35.911,0,49.6V132.08C0,145.766,10.8,156.9,24.065,156.9H457.786c13.27,0,24.065-11.137,24.065-24.823V49.6C481.851,35.911,471.055,24.774,457.786,24.774Zm8,107.307a8.169,8.169,0,0,1-8,8.306H24.065a8.169,8.169,0,0,1-8-8.306V49.6a8.169,8.169,0,0,1,8-8.306H457.786a8.169,8.169,0,0,1,8,8.306v82.485Z",
    transform: "translate(0 -24.774)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 164.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M457.786,165.161H24.065C10.8,165.161,0,176.3,0,189.984v82.484c0,13.685,10.8,24.823,24.065,24.823H457.786c13.27,0,24.065-11.137,24.065-24.823V189.984C481.851,176.3,471.055,165.161,457.786,165.161Zm8,107.307a8.169,8.169,0,0,1-8,8.306H24.065a8.169,8.169,0,0,1-8-8.306V189.984a8.169,8.169,0,0,1,8-8.306H457.786a8.169,8.169,0,0,1,8,8.306v82.484Z",
    transform: "translate(0 -165.161)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(41.291 66.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M66.065,66.064A24.774,24.774,0,1,0,90.839,90.838,24.8,24.8,0,0,0,66.065,66.064Zm0,33.033a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,66.065,99.1Z",
    transform: "translate(-41.291 -66.064)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(41.291 205.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M66.065,206.452a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,66.065,206.452Zm0,33.032a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,66.065,239.484Z",
    transform: "translate(-41.291 -206.452)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(96.175 66.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M123.871,66.064a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,123.871,66.064Zm0,33.033a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,123.871,99.1Z",
    transform: "translate(-99.097 -66.064)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(96.175 205.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M123.871,206.452a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,123.871,206.452Zm0,33.032a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,123.871,239.484Z",
    transform: "translate(-99.097 -206.452)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(152.278 66.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M181.678,66.064a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,181.678,66.064Zm0,33.033a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,181.678,99.1Z",
    transform: "translate(-156.904 -66.064)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(152.278 205.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M181.678,206.452a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,181.678,206.452Zm0,33.032a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,181.678,239.484Z",
    transform: "translate(-156.904 -206.452)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(382.754 57.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M429.42,57.806a33.032,33.032,0,1,0,33.032,33.032A33.067,33.067,0,0,0,429.42,57.806Zm0,49.549a16.516,16.516,0,1,1,16.516-16.516A16.535,16.535,0,0,1,429.42,107.355Z",
    transform: "translate(-396.388 -57.806)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(382.754 197.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M429.42,198.193a33.032,33.032,0,1,0,33.032,33.032A33.067,33.067,0,0,0,429.42,198.193Zm0,49.549a16.516,16.516,0,1,1,16.516-16.516A16.535,16.535,0,0,1,429.42,247.742Z",
    transform: "translate(-396.388 -198.193)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(0 304.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M457.786,305.548H24.065C10.8,305.548,0,316.686,0,330.371v82.484c0,13.685,10.807,24.823,24.088,24.823h288.64a8.261,8.261,0,0,0,0-16.516H24.088a8.179,8.179,0,0,1-8.027-8.306V330.372a8.169,8.169,0,0,1,8-8.306H457.786a8.112,8.112,0,0,1,8,8.194v8.847a8.034,8.034,0,1,0,16.062,0V330.26C481.851,316.637,471.055,305.548,457.786,305.548Z",
    transform: "translate(0 -305.548)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(41.291 345.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M66.065,346.839a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,66.065,346.839Zm0,33.032a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,66.065,379.871Z",
    transform: "translate(-41.291 -346.839)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(96.175 345.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M123.871,346.839a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,123.871,346.839Zm0,33.032a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,123.871,379.871Z",
    transform: "translate(-99.097 -346.839)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(152.278 345.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M181.678,346.839a24.774,24.774,0,1,0,24.774,24.774A24.8,24.8,0,0,0,181.678,346.839Zm0,33.032a8.258,8.258,0,1,1,8.258-8.258A8.267,8.267,0,0,1,181.678,379.871Z",
    transform: "translate(-156.904 -346.839)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(316.69 337.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M510.747,474.589,428.166,342.46c-3.024-4.823-10.984-4.823-14.008,0L331.577,474.589a8.262,8.262,0,0,0,7,12.637H503.743a8.262,8.262,0,0,0,7-12.637ZM353.48,470.71l67.682-108.29,67.682,108.29Z",
    transform: "translate(-330.324 -338.843)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(399.27 378.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M421.162,379.871a8.256,8.256,0,0,0-8.258,8.258v41.29a8.258,8.258,0,0,0,16.516,0v-41.29A8.256,8.256,0,0,0,421.162,379.871Z",
    transform: "translate(-412.904 -379.871)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(399.27 444.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M427.025,448.331a8.258,8.258,0,0,0-14.121,5.863,8.174,8.174,0,0,0,2.395,5.863,9.508,9.508,0,0,0,2.722,1.734,8.178,8.178,0,0,0,11.4-7.6A8.691,8.691,0,0,0,427.025,448.331Z",
    transform: "translate(-412.904 -446.038)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/Server.bad857ea8b14a10fb4be8f62bb351989.svg";
export { ForwardRef as ReactComponent };